import { useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { z } from 'zod';


const schema = z.object({
  fullName: z.string().trim().min(1, "Please Enter your Name"),
  phone: z.string().trim().regex(/^\d{10}$/, "Enter a valid 10-digit phone number"),
  email: z.string().trim().regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email address"),

})

const ContactInfo = () => {

  const { bookingData, setBookingData } = useOutletContext();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();


  const customer = bookingData?.customer || {
    fullName: "",
    phone: "",
    email: "",
    notes: "",
  };

  const updateCustomer = (key, value) => {
    setBookingData((prev) => ({
      ...prev,
      customer: {
        ...(prev.customer || { fullName: "", phone: "", email: "" }),
        [key]: value,
      },
    }));
  };

  const validateForm = () => {
      // e.preventDefault();
  
      const validate = schema.safeParse(customer);
  
      if (!validate.success) {
        const tree = z.treeifyError(validate.error);
        const props = tree?.properties ?? {};
        setErrors({
          fullName: props.fullName?.errors?.[0],
          phone: props.phone?.errors?.[0],
          email: props.email?.errors?.[0],
          });
        
        return false;
        
      }  
      setErrors({})
      return true;     
    }
    const proceedNext = () => {
    const validateConfirm = validateForm();
    if (validateConfirm) {
      navigate("/appointments/reviewAppointment");
    };

      // navigate("/appointments/reviewAppointment");


  }



  return (
    <section className="mt-8 rounded-2xl bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold text-gray-900">
        Contact Information
      </h2>
      <p className="mt-1 text-sm text-gray-600">
        Please provide your contact details so we can confirm your appointment.
      </p>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Full Name
          </label>
          <input
            type="text"
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="John Doe"
            value={customer.fullName}
            onChange={(e) => updateCustomer("fullName", e.target.value)}
          />
          {errors.fullName && <p className="mt-1 text-sm text-red-600">{errors.fullName}</p>}
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700">
            Phone Number
          </label>
          <input
            type="tel"
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="(226) 456-1820"
            value={customer.phone}
            onChange={(e) => updateCustomer("phone", e.target.value)}
          />
          {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}

        </div>
      </div>

      <div className="mt-4">
        <label className="mb-1 block text-sm font-medium text-gray-700">
          Email Address
        </label>
        <input
          type="email"
          className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          placeholder="john@example.com"
          value={customer.email}
          onChange={(e) => updateCustomer("email", e.target.value)}
        />
          {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}

      </div>

      <div className="mt-8 flex justify-between">
        <Link
          to="/appointments/date"
          className="rounded-xl border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 hover:bg-gray-50"
        >
          ← Back
        </Link>

        <button
          onClick={proceedNext}
          className={"rounded-xl px-6 py-3 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-500"}
        >
          Review Booking →
        </button>
      </div>
    </section>
  );
};

export default ContactInfo;
